exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".correct-answer---169RV{border-radius:20px;border:1px solid #bcedbd;margin-top:20px}.correct-answer---169RV .correct-answer-text---3aG-T{background-color:#f6fef4;text-align:center;border-radius:20px 20px 0 0;padding:10px 0}.correct-answer---169RV .correct-answer-container---Ycx5h{padding:10px}.correct-answer---169RV *[data-type=\"default-content\"]{display:none}", ""]);

// exports
exports.locals = {
	"correct-answer": "correct-answer---169RV",
	"correct-answer-text": "correct-answer-text---3aG-T",
	"correct-answer-container": "correct-answer-container---Ycx5h"
};